var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightTakeoff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M29.24 12.558l-7.965 2.13-6.525 1.74-7.965 2.13-2.4.645-1.155-1.995-2.73-4.74 2.175-.585 2.955 2.31 7.455-1.995-6.21-10.755L9.77.678l10.35 9.645 7.965-2.13c1.2-.33 2.445.39 2.76 1.59.315 1.2-.39 2.43-1.605 2.775zM1.49 23.823h28.5v3H1.49z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightTakeoff);
export default __webpack_public_path__ + "static/media/flight-takeoff.c09d80a02fecb3440aa45cad92f5a25d.svg";
export { ForwardRef as ReactComponent };